import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../config';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await axios.post(`${API_BASE_URL}/api/auth/forgot-password`, { email });
      setSubmitted(true);
    } catch {
      setError('Ocurrió un error. Por favor intenta nuevamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-image"></div>
      <div className="login-form-container">
        <form onSubmit={handleSubmit} className="login-form">
          <h2><span className="taxi-highlight">TⒶXí</span> te lleva al futuro de la contabilidad</h2>
          <p>Recuperar contraseña</p>

          {submitted ? (
            <div style={{ textAlign: 'center' }}>
              <p style={{ color: '#4f46e5', marginBottom: '16px' }}>
                Si el correo está registrado, recibirás un email con instrucciones en los próximos minutos.
              </p>
              <p style={{ fontSize: '13px', color: '#888' }}>
                Revisa también tu carpeta de spam.
              </p>
              <Link to="/login" style={{ display: 'block', marginTop: '16px', color: '#4f46e5' }}>
                Volver al login
              </Link>
            </div>
          ) : (
            <>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Ingresa tu correo"
                required
              />
              {error && <p style={{ color: 'red', fontSize: '13px' }}>{error}</p>}
              <button type="submit" disabled={loading}>
                {loading ? 'Enviando...' : 'Enviar instrucciones'}
              </button>
              <Link to="/login" className="forgot-password">Volver al login</Link>
            </>
          )}
        </form>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
